import type {ReactElement} from 'react';
import {StylePresetSelectorControl} from '@FormMakerReact/layout/form-maker-right-panel/controls/style-preset-selector-control/style-preset-selector-control';
import {ALIGNMENT_PRESETS} from '@FormMakerReact/layout/form-maker-right-panel/sectors/form-background-presets';
import {isUnderSignupForm} from '@FormMakerReact/layout/form-maker-right-panel/components/signup-only/is-under-signup-form';
import type {ConfirmationAlignmentControlProps} from './confirmation-alignment-control.types';

export function ConfirmationAlignmentControl({component}: ConfirmationAlignmentControlProps): ReactElement | null {
  if (isUnderSignupForm(component)) {
    return null;
  }
  return <StylePresetSelectorControl component={component} property="align-items" labelKey="pmwjs_form_maker_control_alignment_label" presets={ALIGNMENT_PRESETS} />;
}
